import { Component, Input, OnInit } from '@angular/core';
import { IBrandResources } from 'src/app/domain/interfaces/brand/interface-brand-resources';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-footer-secondary-brand-funnels',
  templateUrl: './footer-secondary-brand-funnels.component.html',
  styleUrls: ['./footer-secondary-brand-funnels.component.scss']
})
export class FooterSecondaryBrandFunnelsComponent implements OnInit {
  @Input() currentYear!: number;
  @Input() brandResources!: IBrandResources;
  @Input() IsOrganicFunnel!: boolean;
  public environment = environment;

  constructor() { }

  ngOnInit(): void {
  }

}
